import React from 'react'
import { Card } from 'antd'
import { Column } from '@ant-design/plots'
import type { MonthlyRevenue } from '../types/analytics.types'

interface RevenueChartProps {
    data: MonthlyRevenue[]
}

export const RevenueChart: React.FC<RevenueChartProps> = ({ data }) => {
    const config = {
        data,
        xField: 'month',
        yField: 'revenue',
        label: {
            text: (d: any) => d.revenue,
            textBaseline: 'bottom',
            position: 'top',
            style: {
                fill: '#262626',
                fontWeight: 600,
            },
        },
        axis: {
            y: { title: false },
        },
        color: '#1890ff',
    } as any // as any to avoid type issues with Ant Design Charts v1 vs v2

    return (
        <Card 
            title="Revenue Trend (Last 6 Months)" 
            style={{ height: '100%', display: 'flex', flexDirection: 'column' }} 
            styles={{ body: { flex: 1 } }}
        >
            <Column {...config} />
        </Card>
    )
}
